export const RESET_STORE = 'global/RESET_STORE'
export const PATTERN_EMAIL = /^[A-Z0-9a-z._-]+@[A-Z0-9a-z._-]+$/
export const PATTERN_PASSWORD = /^.{6,}$/
// API
// ... URL CONSTANTS
export const API_URL_REFRESH_TOKEN = '/token/refresh'

export const APP_URL_USER_LIST = '/users'
export const APP_URL_USER_CREATE = `${APP_URL_USER_LIST}/create`
export const APP_URL_USER_EDIT = `${APP_URL_USER_LIST}/{:id}`
export const API_URL_USER_INVITATION = `${APP_URL_USER_EDIT}/invitation`
export const API_URL_USER_SET_PASSWORD = `${APP_URL_USER_EDIT}/update-password`
export const API_URL_USER_PROFILE = '/user/profile'
export const API_URL_USER_PROFILE_UPDATE_MNA_FILTERS = `${API_URL_USER_PROFILE}/mna-filters`
export const API_URL_USER_PROFILE_UPDATE_LOGBOOK_FILTERS = `${API_URL_USER_PROFILE}/logbook-filters`
export const API_URL_USER_PROFILE_PHOTO = '/user/profile/photo'
export const API_URL_USER_PROFILE_UPDATE_PASSWORD =
  '/user/profile/update-password'
export const API_URL_ROLES_LIST = '/roles'

export const API_URL_LICENSEE_LIST = '/licensees'
export const API_URL_LICENSEE_TABLE = '/licensees/table'
export const API_URL_LICENSEE_LIST_BY_USER = '/licensees/user/data'
export const API_URL_LICENSEE_ITEM = '/licensees/{:id}'

export const API_URL_SITE_LIST = '/sites'
export const API_URL_SITE_TABLE = '/sites/table'
export const API_URL_SITE_ITEM = '/sites/{:id}'
export const API_URL_SITE_DASHBOARD =
  '/dashboard/site-info/{:id}/{:startDate}/{:endDate}'
export const API_URL_SITE_LIST_BY_USER = '/sites/user/data'
export const API_URL_SITE_LIST_BY_SUPER_USER =
  '/sites/super-user/{:licensee}/data'

export const API_URL_DASHBOARD_LIST = '/dashboard/{:startDate}/{:endDate}'
export const API_URL_DASHBOARD_SITE_TYPES = '/dashboard/sites-type'

export const API_URL_LOCUS_LIST = '/locuses'
export const API_URL_LOCUS_TABLE = '/locuses/table'
export const API_URL_LOCUS_ITEM = '/locuses/{:id}'
export const API_URL_LOCUS_FROM_SITE = '/locuses/site/{:id}'

export const API_URL_SATELLITE_LIST = '/satellite/{:site}/{:type}/{:date}/data'
export const API_URL_SATELLITE_TYPE_LIST = '/satellite/types'
export const API_URL_MORTALITY_LIST =
  '/mortality/{:locus}/{:startDate}/{:endDate}/data'

export const API_URL_AUDIT = '/audit'
export const API_URL_AUDIT_TABLE = '/audit/table'
export const API_URL_AUDIT_TABLE_FILTERS = '/audit/table-filters'

export const API_URL_DL_MORTALITY_ACTIVE_SITES =
  '/dl/active-sites?site_type={:site_type}'
export const API_URL_DL_MORTALITY_DATE_FILTER =
  '/dl/mortality/date-filter/{:siteId}'
export const API_URL_DL_MORTALITY_LOCUS_HISTORY =
  '/dl/mortality/locus-history/{:siteId}/{:year}/{:week}'

export const API_URL_APPLICATION_LIST = '/applications'
export const API_URL_APPLICATION_TABLE = '/applications/table'
export const API_URL_APPLICATION_ITEM = '/applications/{:id}'

// translation
export const API_URL_TRANSLATION_JOB_WORKFLOW_TABLE =
  '/job-workflows/translation/table'
export const API_URL_TRANSLATION_JOB_WORKFLOW_ITEM =
  '/job-workflows/translation/{:id}'
export const API_URL_TRANSLATION_JOB_WORKFLOW_TASK_TABLE =
  '/job-workflow-tasks/translation/table'
export const API_URL_TRANSLATION_JOB_WORKFLOW_TASK_ITEM =
  '/job-workflow-tasks/translation/{:id}'
export const API_URL_TRANSLATION_JOB_WORKFLOW_INPUT_TABLE =
  '/job-workflow-inputs/translation/table'
export const API_URL_TRANSLATION_JOB_WORKFLOW_INPUT_ITEM =
  '/job-workflow-inputs/translation/{:id}'
export const API_URL_TRANSLATION_LOGBOOK_EVENT_TABLE =
  '/logbook-events/translation/table'
export const API_URL_TRANSLATION_LOGBOOK_EVENT_ITEM =
  '/logbook-events/translation/{:id}'
export const API_URL_TRANSLATION_LOGBOOK_FORM_TABLE =
  '/logbook-forms/translation/table'
export const API_URL_TRANSLATION_LOGBOOK_FORM_ITEM =
  '/logbook-forms/translation/{:id}'
export const API_URL_TRANSLATION_LOGBOOK_EVENT_CATEGORY_TABLE =
  '/logbook-event-categories/translation/table'
export const API_URL_TRANSLATION_LOGBOOK_EVENT_CATEGORY_ITEM =
  '/logbook-event-categories/translation/{:id}'
export const API_URL_TRANSLATION_MONITORING_ALERTS_TABLE =
  '/monitoring-alerts/translation/table'
export const API_URL_TRANSLATION_MONITORING_ALERTS_ITEM =
  '/monitoring-alerts/translation/{:id}'
export const API_URL_TRANSLATION_SENSOR_TYPE_TABLE =
  '/sensor-types/translation/table'
export const API_URL_TRANSLATION_SENSOR_TYPE_ITEM =
  '/sensor-types/translation/{:id}'

// ...ERRORS CONSTANTS
export const ERROR_TYPE_API_SERVER_NOT_RESPONDING = 'API_SERVER_NOT_RESPONDING'
export const ERROR_TYPE_API_SERVER_ERROR = 'API_SERVER_ERROR'
export const ERROR_TYPE_API_TOKEN_EXPIRED = 'API_TOKEN_EXPIRED'
export const ERROR_TYPE_API_INVALID_FORM_DATA = 'API_INVALID_FORM_DATA'

// APP
// ... URL CONSTANTS
export const APP_URL_ERROR_NOT_FOUND = '/404'
export const APP_URL_ERROR_ACCESS_DENIED = '/403'
export const APP_URL_LOGIN = '/login'
export const APP_URL_FORGOT_PASSWORD = '/login/forgot-password'
export const APP_URL_RECOVERY_PASSWORD = '/login/recovery-password/:token'
export const APP_URL_PROFILE = '/profile'
export const APP_URL_DASHBOARD = '/dashboard'
export const APP_URL_LICENSEE_LIST = '/licensees'
export const APP_URL_LICENSEE_CREATE = '/licensees/create'
export const APP_URL_LICENSEE_EDIT = '/licensees/{:id}'
export const APP_URL_SITE_LIST = '/sites'
export const APP_URL_SITE_CREATE = '/sites/create'
export const APP_URL_SITE_EDIT = '/sites/{:id}'
export const APP_URL_LOCUS_LIST = '/locuses'
export const APP_URL_LOCUS_CREATE = '/locuses/create'
export const APP_URL_LOCUS_EDIT = '/locuses/{:id}'
export const APP_URL_AUDIT = '/audit'
export const APP_URL_MORTALITY = '/mortality'
export const APP_URL_SATELLITE = '/satellite'

// ... ERRORS CONSTANTS
export const APP_ERROR_TYPE_COMMON = 'APP_ERROR_TYPE_COMMON'
export const APP_ERROR_TYPE_INCORRECT_REQUEST =
  'APP_ERROR_TYPE_INCORRECT_REQUEST'

// ... COMMON CONSTANTS
export const APP_PREVIOUS_URL = 'APP_PREVIOUS_URL'
export const PHOTO_VALID = {
  fileSize: 8097152,
  fileType: [
    'image/png',
    'image/svg+xml',
    'image/jpg',
    'image/jpeg',
    'image/PNG',
    'image/JPG',
    'image/JPEG',
  ],
  userInfo: {
    fileSize: '8Mb',
    fileType: '.PNG or .JPG or .JPEG or .SVG',
  },
}
export const SVG_IMAGE_TYPE = 'image/svg+xml'
export const APP_LANGUAGES = {
  en: {
    key: 'en',
    title: 'english',
  },
  es: {
    key: 'es',
    title: 'spain',
  },
  no: {
    key: 'no',
    title: 'norwegian',
  },
  pl: {
    key: 'pl',
    title: 'polish',
  },
  pt: {
    key: 'pt',
    title: 'portugal',
  },
  ru: {
    key: 'ru',
    title: 'russian',
  },
  th: {
    key: 'th',
    title: 'thai',
  },
  uk: {
    key: 'uk',
    title: 'ukrainian',
  },
}

export const LOOKUP_DISPLAY_TYPE = 'display'
export const LOOKUP_UPDATE_TYPE = 'update'
export const LOOKUP_ADD_TYPE = 'add'
export const LOOKUP_SUBTRACT_TYPE = 'subtract'

export const NUMBER_INPUT_CONDITION_TYPES = [
  LOOKUP_DISPLAY_TYPE,
  LOOKUP_UPDATE_TYPE,
  LOOKUP_ADD_TYPE,
  LOOKUP_SUBTRACT_TYPE,
]
export const STRING_OR_DATE_INPUT_CONDITION_TYPES = [
  LOOKUP_DISPLAY_TYPE,
  LOOKUP_UPDATE_TYPE,
]
export const URL_ECTO = 'www.ecto.com'
export const URL_ECTO_WATER_FORM = 'https://ecto.com/'

export const isIE = /Trident\/|MSIE/.test(window.navigator.userAgent)

export const MULTIPLE_VALUE_TYPE = 'multiple_values_per_day'
export const MULTIPLE_ROW_TYPE = 'multiple_rows_per_day'
export const SINGLE_VALUE_TYPE = 'one_value_per_day'

export const JOBS_DATA_VIEWER_DEFAULT_FIELDS = ['job', 'job_input']

export const ALL_SELECTED = 'all_selected'
export const EMPTY = 'empty'
export const IS_ADMIN_QUERY_PARAM = 'admin=1'

export const ONE_YEAR_IN_MONTHES = 12
export const MAXIMUM_POSSIBLE_DATE = 8.64e15

export const SITE_TYPE_SEAWATER = 'seawater'
export const SITE_TYPE_FRESHWATER = 'freshwater'

export const MANAGEMENT_UI_EVERYTHING = 'everything'
export const MANAGEMENT_UI_TEAMS = 'teams'
export const MANAGEMENT_UI_SCHEDULING = 'scheduling'
export const MANAGEMENT_UI_DELETED = 'deleted'
export const STATUS_TYPE_NOT_STARTED = 'not_started'
export const STATUS_TYPE_IN_PROGRESS = 'in_progress'
export const STATUS_TYPE_COMPLETED = 'completed'

export const LATER = 'later'
export const HIGHER = 'higher'
export const LATER_OR_SAME = 'later_or_same'
export const EQUAL_OR_HIGHER = 'equal_or_higher'
export const SAME = 'same'
export const EQUAL = 'equal'
export const EARLIER_OR_SAME = 'earlier_or_same'
export const EQUAL_OR_LOWER = 'equal_or_lower'
export const EARLIER = 'earlier'
export const LOWER = 'lower'

export const ACTION_DUPLICATE = 'duplicate'
export const ACTION_DELETE = 'delete'
export const ACTION_DUPLICATE_WITH_DATA = 'duplicate-with-data'

export const DUPLICATE_INSERT_PARAMETER_AFTER = 'after'

export const SITE_TYPE_REGEXP = new RegExp(
  `/${SITE_TYPE_FRESHWATER}|${SITE_TYPE_SEAWATER}/`,
  'g',
)

export const ASSIGNED = 'Assigned'
export const USER_GROUP = 'User Group'
export const USERS = 'Users'
export const ASSIGNEE_TYPE_USER = 'user'
export const ASSIGNEE_TYPE_USER_GROUP = 'user_group'
export const SELECT_ACTION_ADD = 'add'
export const SELECT_ACTION_REMOVE = 'remove'

export const FEATURE_FLAGS_KEY = 'featureFlags'

export const ITEM_GROUP_NUMBER = 1
export const LEAVE_FEEDBACK_NAME = 'leaveFeedback'
export const RIGHT_SIDE_GROUP = 'right side'

export const ASSIGNED_USERS = 'assignedUsers'
export const ASSIGNED_USER_GROUPS = 'assignedUserGroups'
